import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import ChevronIcon from "assets/icons/ChevronIcon";
import { useEffect, useRef, useState } from "react";
import FilterMenu from "views/components/FilterMenu";
import FilterMenuIcon from "assets/icons/FilterMenuIcon";
import { getShowQueryPanel } from "redux/SingleDataset/selectors";
import { State } from "redux/store";
import useVqlParams from "hooks/useVqlParams";

import styles from "./style.module.scss";
import {
  setSelectedQueryModal,
  setShowQueryPanel,
} from "redux/SingleDataset/actions";

import { FilterMenuItemType, Position } from "types";

const BTN_HEIGHT_WITH_OFFSET = 44;

const AddFilterButton = () => {
  const { vqlQueries } = useVqlParams();
  const isFilterApplied = vqlQueries.length > 0;
  const showPanel = useSelector((state: State) =>
    getShowQueryPanel(state, vqlQueries),
  );
  const [showMenu, setShowMenu] = useState(false);
  const [modalPosition, setModalPosition] = useState<Position | null>(null);
  const btnRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  const title = isFilterApplied ? `${vqlQueries.length}` : "Add Filter";

  const btnClassnames = classNames(styles.addFilterButton, {
    [styles.selected]: showPanel,
  });

  const handleClick = () => {
    if (!isFilterApplied) {
      setShowMenu(!showMenu);
      return;
    }

    dispatch(setShowQueryPanel(!showPanel));
  };

  const handleFilterSelection = (type: FilterMenuItemType) => {
    if (modalPosition) {
      dispatch(setSelectedQueryModal({ type, position: modalPosition }));
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!btnRef.current?.contains(event.target as Node)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    if (btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      const top = rect.top + BTN_HEIGHT_WITH_OFFSET; // adjust for modal position
      setModalPosition({ top, left: rect.left });
    }
  }, [showMenu, isFilterApplied]);

  return (
    <div className={styles.btnWrapper} onClick={handleClick} ref={btnRef}>
      <div className={btnClassnames}>
        {isFilterApplied ? (
          <div className={styles.iconWrapper}>
            <span className={styles.floatingTitle}>{title}</span>
            <FilterMenuIcon variant={!isFilterApplied ? "add" : "default"} />
          </div>
        ) : (
          <>
            <FilterMenuIcon variant={!isFilterApplied ? "add" : "default"} />
            <span className={styles.title}>{title}</span>
          </>
        )}
        {isFilterApplied && (
          <ChevronIcon direction={showPanel ? "up" : "down"} />
        )}
      </div>
      {showMenu && !isFilterApplied && (
        <div className={styles.positioner}>
          <FilterMenu onSelect={handleFilterSelection} />
        </div>
      )}
    </div>
  );
};

export default AddFilterButton;
